import { propertyType, t } from '@blocksuite/data-view';
import zod from 'zod';

export const rowNumberColumnType = propertyType('row-number');
export const rowNumberPropertyModelConfig = rowNumberColumnType.modelConfig({
  name: 'Строка',
  propertyData: {
    schema: zod.object({}),
    default: () => ({}),
  },
  jsonValue: {
    schema: zod.number().nullable(),
    isEmpty: () => false,
    type: () => t.number.instance(),
  },
  rawValue: {
    schema: zod.number().nullable(),
    default: () => null,
    toString: ({ value }) => (value == null ? '' : String(value)),
    fromString: () => {
      return { value: null };
    },
    toJson: () => null,
    setValue: () => {
      // row number is computed from the row index and cannot be set
    },
  },
});
